const environments = {
  develop: 'DEVELOP',
  test: 'TEST',
  stage: 'STAGE',
  production: 'PRODUCTION'
};
export const allEnvironments = Object.keys(environments);
export const isEnvironment = value => !!environments[value];
export const getEnvironment = value => isEnvironment(value) ? value : undefined;
export const getEnvironmentFallbackDev = value => getEnvironment(value) ?? 'develop';